<template>
  <div class="page">
    <p class="add-bold no-indent">有看投用户使用协议</p>
    <p class="add-bold no-indent">特别提示</p>
    <p class="add-bold">
      欢迎使用上海第一财经传媒有限公司为您提供的有看投平台。请您务必审慎并完整阅读以下内容，特别是免除或者限制有看投责任的条款、对用户权利进行限制的条款、规定本协议的适用法律及有权解决争议的司法管辖区的条款。限制、免责条款或者其他涉及您重大权益的条款可能以加粗等形式提示您重点注意。请注意，目前在您的地区可能无法使用有看投平台上的某些服务和功能（特别是涉及支付的功能）。给您带来的不便，我们深表歉意，并正在努力尽快（如可能）提供这些服务和功能。
    </p>
    <p class="add-bold">
      如您未满18周岁或未满您居住所在地要求可使用有看投平台的年龄，请不要使用有看投平台。
    </p>
    <p class="add-bold">
      除非您已充分阅读并接受本协议所有条款，否则您无权使用有看投平台。如您不同意本协议或其中任何条款，您应立即停止使用有看投平台。您点击“同意”，或者您使用有看投平台，或者以其他任何明示或者默示方式表示接受本协议的，均视为您已阅读并同意本协议。本协议即在您与上海第一财经传媒有限公司之间产生法律效力，成为对双方均具有约束力的法律文件。
    </p>
    <p class="add-bold no-indent">1.定义及协议范围</p>
    <p class="add-bold">1.1定义</p>
    <p>
      有看投平台：指上海第一财经传媒有限公司及其全资子公司上海第一财经投资管理有限公司（以下简称“有看投公司”或“我们”）合法拥有并运营的名称为“有看投”，和/或“yicaiykt”的网站、小程序、客户端应用程序以及我们不时提供的其他形式。“我们的”应相应地进行理解。为免疑义，我们亦保留调整有看投平台名称的所有权利。
    </p>
    <p>
      有看投平台服务：指有看投公司通过有看投平台为您提供内容浏览、内容发布、商品与服务交易、直播以及包括但不限于收藏、评论、分享、转发、搜索查询、平台活动等其他各项功能或服务，具体以有看投公司实际提供的为准。同时，有看投公司有权对提供的该等功能或服务进行增加、关停或其他调整。
    </p>
    <p>
      有看投账号或账号：指用户在使用有看投平台时可能需要注册的账号。我们为用户提供有看投平台注册通道，您可通过移动电话号码或我们允许的其他方式注册有看投账号。
    </p>
    <p>
      用户：指有看投平台的使用人，在本协议中更多地称为“您”。“您的”应相应地进行理解。
    </p>
    <p>不良信息：指含有下列内容的信息：</p>
    <p>
      ·违反中国宪法确定的基本原则，煽动抗拒或者破坏中国宪法等法律法规实施的；
    </p>
    <p>
      ·危害中国国家统一、主权和领土完整，泄露中国国家秘密，危害中国国家安全，损害中国国家尊严、荣誉和利益，宣扬恐怖主义、极端主义的；
    </p>
    <p>
      ·诋毁中华民族优秀文化传统，煽动民族仇恨、民族歧视，侵害中华民族风俗习惯，歪曲中华民族历史和民族历史人物，伤害民族感情，破坏民族团结的；
    </p>
    <p>
      ·煽动破坏中国国家宗教政策，宣扬宗教狂热，危害宗教和睦，伤害信教公民宗教感情，破坏信教公民和不信教公民团结，宣扬邪教、迷信的；
    </p>
    <p>
      ·危害中国社会公德，扰乱中国社会秩序，破坏中国社会稳定，宣扬淫秽、赌博、吸毒，渲染暴力、恐怖，教唆犯罪或者传授犯罪方法的；
    </p>
    <p>·侵害未成年人合法权益或者损害未成年人身心健康的；</p>
    <p>·侮辱、诽谤他人或者散布他人隐私，侵害他人合法权益的；</p>
    <p>
      ·违反法律法规底线、中国社会主义制度底线、中国国家利益底线、中国公民合法权益底线、中国社会公共秩序底线、道德风尚底线和信息真实性底线的“七条底线”要求的；
    </p>
    <p>·法律法规禁止的其他内容。</p>
    <p class="add-bold">1.2 协议范围</p>
    <p>
      本协议是您与有看投公司之间关于您下载、安装、使用有看投平台所订立的协议，包括<span
        class="add-bold"
        >本协议正文、</span
      ><span class="add-color" @click="openurl(privacyAgreement)"
        >《隐私政策》</span
      ><span class="add-color" @click="openurl(bagProducts)"
        >《有看投用户锦囊产品服务购买协议》</span
      ><span class="add-color" @click="openurl(videoAgreement)"
        >《第一财经有看投视频收费协议》</span
      ><span class="add-color" @click="openurl(memberAgreement)"
        >《有看投会员产品服务协议》</span
      >及有看投公司已经发布的或将来可能发布/更新的并采取合理途径通知的各类规则、规范、通知等。所有规则均为本协议不可分割的组成部分，且具有同等法律效力。
    </p>
    <p class="add-bold no-indent">2．服务条款的确认</p>
    <p>
      有看投App平台根据本服务条款及对该条款的修改向用户提供服务。本服务条款具有合同法上的法律效力。
    </p>
    <p>
      如果您对协议的任何条款表示异议，您可以选择不注册，一旦您点选“注册”并通过注册程序，即表示您自愿接受本协议之所有条款，并已成为有看投App平台的注册用户。用户在使用有看投App的同时，同意接受平台注册用户服务提供的各类信息服务。
    </p>
    <p>
      有看投App有权根据互联网的发展和中华人民共和国有关法律、法规的变化，不断地完善服务质量并依此修改本用户协议条款。用户的权利以及义务的表述，均以最新的服务条款为准。服务条款一旦发生变动，将会在重要页面上提示修改内容。如用户仍继续在服务期内使用该软件即视为自动接受服务条款的变动。
    </p>
    <p>
      有看投App平台的注册用户承诺遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等七条底线。
    </p>
    <p>
      有看投App平台的注册用户承诺其注册的账号名称不含不良信息，不良信息见1.1。
    </p>
    <p class="add-bold no-indent">3．服务内容及修改、中断、终止</p>
    <p>
      3.1
      有看投App平台服务的具体内容由本平台根据实际情况提供，并对所提供之服务拥有最终解释权。
    </p>
    <p>
      3.2
      有看投App平台中部分服务仅向注册用户提供，与相关服务有关的设备（如个人电脑、手机、及其他与接入互联网或移动网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）均由注册用户自行负担。
    </p>
    <p>
      3.3 鉴于网络服务的特殊性，
      有看投App会不断完善技术和服务水平，但不担保网络服务不会中断，对网络服务的及时性、安全性、准确性也不作担保。
    </p>
    <p>
      3.4
      有看投App需要定期或不定期地对提供网络服务的平台或相关的设备进行检修或者维护，如因此类情况而造成网络服务（包括收费网络服务）在合理时间内的中断，有看投App平台无需为此承担责任。
    </p>
    <p class="add-bold no-indent">4．注册用户帐号及密码</p>
    <p>
      4.1用户的帐号，密码和安全性。用户一旦注册成功，成为有看投APP的合法用户，将得到一个密码和用户名。该帐号和密码由用户负责保管；用户将对用户名和密码安全负全部责任。另外，每个用户都要对以其用户名进行的所有活动和事件负全责。用户若发现任何非法使用用户帐号或存在安全漏洞的情况，请立即通告APP运营方。
    </p>
    <p class="add-bold no-indent">5. 注册信息和隐私保护</p>
    <p>
      5.1
      用户隐私制度。尊重用户个人隐私是有看投APP的基础原则。有看投不会在未经用户授权时公开或透露其注册资料及其它保存在有看投APP的非公开内容，除非：
    </p>
    <p>事先获得用户的明确授权；</p>
    <p>只有透露你的个人资料，才能提供你所要求的产品和服务；</p>
    <p>根据有关的法律法规要求；</p>
    <p>按照相关政府主管部门的要求；</p>
    <p>为维护有看投App平台的合法权益。</p>
    <p>
      5.2
      在您注册有看投App帐户，使用平台产品或服务，或访问平台网页时，有看投App会收集您的个人身份识别资料，并会将这些资料用于：改进为您提供的服务及网页内容。
    </p>
    <p class="add-bold no-indent">6. 用户权责</p>
    <p>
      6.1符合下列条件之一的个人、组织，才能申请成有看投App用户、使用本协议项下的服务：
    </p>
    <p>6.1.1 年满十八周岁，并具有民事权利能力和民事行为能力的自然人；</p>
    <p>
      6.1.2 未满十八周岁，但监护人（包括但不仅限于父母）予以书面同意的自然人；
    </p>
    <p>
      6.1.3
      根据中国法律、法规成立并合法存在的公司等企业法人、事业单位、社团组织和其他组织。无民事行为能力人、限制民事行为能力人以及无经营或特定经营资格的组织不当注册为用户的，其与本公司之间的协议自始无效，本公司一经发现，有权注销该用户。
    </p>
    <p>
      6.2
      用户有权按照有看投App规定的程序和要求使用平台向注册及付费用户提供的各项网络服务，如果注册用户对该服务有异议，可以与App联系以便得到及时解决。
    </p>
    <p>
      6.3 用户须同意接受有看投App通过短信或其他方式向注册用户发送相关服务信息。
    </p>
    <p>
      6.4
      用户在使用有看投App服务时，必须遵守中华人民共和国相关法律法规的规定，不得利用本服务进行任何违法或不正当的活动，包括但不限于下列行为∶
    </p>
    <p>6.4.1 制作、复制、发布、传播或以其它方式传送含有下列内容之一的信息：</p>
    <p>反对宪法所确定的基本原则的</p>
    <p>危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
    <p>损害国家荣誉和利益的；</p>
    <p>煽动民族仇恨、民族歧视、破坏民族团结的；</p>
    <p>破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
    <p>散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
    <p>散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
    <p>侮辱或者诽谤他人，侵害他人合法权利的；</p>
    <p>煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；</p>
    <p>以非法民间组织名义活动的；</p>
    <p>
      含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其它道德上令人反感的内容；
    </p>
    <p>
      含有中国法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容的。
    </p>
    <p>6.4.2 不得利用有看投App服务从事以下活动：</p>
    <p>未经允许，进入计算机信息网络或者使用计算机信息网络资源；</p>
    <p>未经允许，对计算机信息网络功能进行删除、修改或者增加；</p>
    <p>
      未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加；
    </p>
    <p>故意制作、传播计算机病毒等破坏性程序；</p>
    <p>其他危害计算机信息网络安全的行为。</p>
    <p>
      6.5用户不得对有看投App任何部分通过任何方式进行复制、出售、转售或用于任何其它商业目的。
    </p>
    <p class="add-bold no-indent">7. 知识产权</p>
    <p>
      7.1
      有看投App平台网站及网站所使用的任何相关软件、程序、内容，包括但不限于作品、图片、档案、资料、网站构架、网页设计、经由本网站或广告商向用户呈现的广告或资讯，均由本公司或其它权利人依法享有相应的知识产权，包括但不限于著作权、商标权、专利权或其它专属权利等，受到相关法律的保护。未经本公司或权利人明示授权，用户保证不修改、出租、出借、出售、散布本APP
      所使用的上述任何资料和资源，或根据上述资料和资源制作成任何种类物品。
    </p>
    <p>
      7.2
      本公司授予用户不可转移及非专属的使用权，使用户可以通过单机计算机使用本APP
      的目标代码（以下简称“软件”），但用户不得且不得允许任何第三方，复制、修改、创作衍生作品、进行还原工程、反向组译，或以其它方式破译或试图破译源代码，或出售、转让“软件”或对“软件”进行再授权，或以其它方式移转“软件”之任何权利。用户同意不以任何方式修改“软件”，或使用修改后的“软件”。
    </p>
    <p class="add-bold no-indent">8. 信息授权</p>
    <p>
      8.1
      以第一财经有看投与益盟股份战略合作为前提和基础，有看投部分功能由益盟股份提供维护和技术支持，有看投委托益盟股份对有看投的用户进行客户服务及销售支持。
    </p>
    <p class="add-bold no-indent">9. 收款服务义务、售后</p>
    <p>
      <span class="add-bold">
        不同产品形态的均有单独收银台，产品形态分为锦囊、点金、课程、直播、会员等，其中锦囊、点金订阅型产品可享受7天无理由退换货；课程、直播、会员属于网络虚拟商品，不符合七天无理由退换货原则，服务一经开通无法退换，售后路径为拨打客服电话等客服渠道。</span
      >具体售后可参考<span class="add-color" @click="openurl(bagProducts)"
        >《有看投用户锦囊产品服务购买协议》</span
      ><span class="add-color" @click="openurl(videoAgreement)"
        >《第一财经有看投视频收费协议》</span
      ><span class="add-color" @click="openurl(memberAgreement)"
        >《有看投会员产品服务协议》</span
      >。
    </p>
    <p class="add-bold no-indent">10.其他</p>
    <p>
      10.1
      因不可抗力或者其他意外事件，使得本协议的履行不可能、不必要或者无意义的，双方均不承担责任。本协议所称之不可抗力意指不能预见、不能避免并不能克服的客观情况，包括但不限于战争、台风、水灾、火灾、雷击或地震、罢工、暴动、法定疾病、黑客攻击、网络病毒、电信部门技术管制、政府行为或任何其它自然或人为造成的灾难等客观情况。
    </p>
    <p>
      10.2
      本条款及其修订本的有效性、履行和与本条款及其修订本效力有关的所有事宜，将受中华人民共和国法律约束，任何争议仅适用中华人民共和国法律。
    </p>
    <p>
      10.3
      因本条款所引起的用户与本公司的任何纠纷或争议，首先应友好协商解决，协商不成的，用户在此同意将纠纷或争议提交本公司住所地有管辖权的人民法院诉讼解决。
    </p>
    <p>
      10.4用户正确提交注册程序所需的资料并确认本协议后，本协议在有看投App与用户之间成立并生效。
    </p>
    <p>
      10.5本协议生效前的注册用户只需要使用原用户名及密码登录App重新接受并确认本协议，即可继续使用App的服务。
    </p>
    <p>
      10.6协议有效期：从用户同意本协议或使用有看投App起至用户注销有看投App服务止。
    </p>
    <p>10.7有看投App相关客服的电子邮箱以及联系方式以App官网上注明的为准。</p>
    <p>10.8使用有看投App即表示接受平台服务协议及其所有附件。</p>
    <p>10.9本协议的最终解释权归有看投App所有。</p>
    <p class="no-indent add-margin">
      公司主体：上海第一财经传媒有限公司/上海第一财经投资管理有限公司
    </p>
    <p class="no-indent">更新时间：2025年6月18日</p>
  </div>
</template>

<script>
import { openurl } from '@em/ym'
import Urls from '@/assets/js/Urls'
export default {
  name: 'UserAggrement',
  head: {
    title: '用户协议'
  },
  data() {
    return {
      privacyAgreement: `${Urls.DOMAIN_STATIC}/ykthtml/yktapp/?route=privacy`,
      bagProducts: `${Urls.DOMAIN_STATIC}/ykthtml/agreement/jinnang.html`,
      videoAgreement: `${Urls.DOMAIN_STATIC}/ykthtml/agreement/dianjin.html`,
      memberAgreement: `${Urls.DOMAIN_STATIC}/ykthtml/agreement/member.html`
    }
  },
  setup() {
    return {
      openurl
    }
  }
}
</script>

<style>
body {
  background-color: #ffffff;
}

* {
  padding: 0;
  margin: 0;
}

.black body,
body.black {
  background-color: #111112;
  color: #bfbfbf;
}

.page {
  padding: 15px 15px 30px;
  max-width: 640px;
  margin: 0 auto;
  font-size: 30px;
}

.add-bold {
  font-weight: bold;
}
p {
  text-indent: 2em;
}
.no-indent {
  text-indent: 0em;
}
.add-margin {
  margin-top: 20px;
}
.add-color {
  color: #4690ef;
}
</style>
